var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#1740ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12975_180492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5683 17.8381V20.5989C27.5683 22.0737 26.723 23.2878 25.6888 23.2878H25.1223V24.232C25.1223 25.8507 23.8003 27.1727 22.1816 27.1727H21.3273C21.2104 27.6493 20.7788 28 20.2752 28H18.2698C17.6762 28 17.1816 27.5144 17.1816 26.9119V26.4532C17.1816 25.8597 17.6673 25.3651 18.2698 25.3651H20.2752C20.7788 25.3651 21.2104 25.7158 21.3273 26.1835H22.1816C23.2608 26.1835 24.1331 25.3022 24.1331 24.232V23.2878H23.2248C22.9191 23.2878 22.6673 22.9371 22.6673 22.4964V15.9406C22.6673 15.5 22.9191 15.1493 23.2248 15.1493H23.3597V14.7896C23.3597 12.2536 21.3003 10.1942 18.7644 10.1942H17.3255C14.7896 10.1942 12.7302 12.2536 12.7302 14.7896V15.1493H12.7752C13.0809 15.1493 13.3327 15.509 13.3327 15.9406V22.4964C13.3327 22.9371 13.0809 23.2878 12.7752 23.2878H10.3111C9.27696 23.2878 8.43164 22.0737 8.43164 20.5989V17.8381C8.43164 16.3633 9.27696 15.1493 10.3111 15.1493H10.536V14.7896C10.536 11.0486 13.5845 8 17.3255 8H18.7644C22.5054 8 25.5539 11.0486 25.5539 14.7896V15.1493H25.6888C26.723 15.1403 27.5683 16.3543 27.5683 17.8381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12975_180492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1367,
    height: 20,
    fill: "white",
    transform: "translate(8.43164 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrmIcon);
export default __webpack_public_path__ + "static/media/PRM_icon.4554d293.svg";
export { ForwardRef as ReactComponent };